import { navigationContent } from "../app/navigation-content";
import useNavigateToDiary from "../../diaries/hooks/useNavigateToDiary";
import { usePatientsCopy } from "@/features/i18n/patientsCopy";
import { useProfileCopy } from "@/features/i18n/profileCopy";
import { useStudiesCopy } from "@/features/i18n/studiesCopy";
import { useTemplatesCopy } from "@/features/i18n/templatesCopy";
import { useAnalyticsCopy } from "@/features/i18n/analyticsCopy";
import { useAuth } from "@/utils/auth";

const useNavigationContent = () => {
    const { navigateToDiary } = useNavigateToDiary();
    const profileCopy = useProfileCopy();
    const patientsCopy = usePatientsCopy();
    const templatesCopy = useTemplatesCopy();
    const studiesCopy = useStudiesCopy();
    const analyticsCopy = useAnalyticsCopy();
    const auth = useAuth();

    const dynamicNavigation = navigationContent.map((item) => {
        if (item.href === "/profile") {
            return {
                ...item,
                name: profileCopy.title,
                description: profileCopy.navProfileDescription,
            };
        }

        if (item.href === "/diaries") {
            return {
                ...item,
                name: profileCopy.navDiaryLabel,
                description: profileCopy.navDiaryDescription,
                onClick: navigateToDiary,
            };
        }

        if (item.href.startsWith("/patients")) {
            return {
                ...item,
                name: patientsCopy.patients,
                description: patientsCopy.navPatientsDescription,
            };
        }

        if (item.href === "/templates") {
            return {
                ...item,
                name: templatesCopy.templates,
                description: templatesCopy.navDescription,
            };
        }

        if (item.href === "/studies") {
            return {
                ...item,
                name: studiesCopy.studies,
                description: studiesCopy.description,
            };
        }

        if (item.href === "/team") {
            return {
                ...item,
                name: profileCopy.myTeam,
                description: profileCopy.teamPageDescription,
            };
        }

        if (item.href === "/validate" && auth.roles.isAdmin) {
            return {
                ...item,
                description: auth.roles.isValidator
                    ? "Review items assigned to you. You can also invite a colleague or record a sign-off received outside the app."
                    : "Invite a colleague to review a form or schedule, or record a sign-off received outside the app.",
            };
        }

        if (item.href === "/analytics") {
            return {
                ...item,
                name: analyticsCopy.navTitle,
                description: analyticsCopy.navDescription,
            };
        }

        return item;
    });

    return dynamicNavigation;
};

export default useNavigationContent;
